import { render, staticRenderFns } from "./AssignCustomerToProject.vue?vue&type=template&id=65dd128a&scoped=true"
import script from "./AssignCustomerToProject.vue?vue&type=script&lang=js"
export * from "./AssignCustomerToProject.vue?vue&type=script&lang=js"
import style0 from "./AssignCustomerToProject.vue?vue&type=style&index=0&id=65dd128a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dd128a",
  null
  
)

export default component.exports